/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  INearbyHousesExplanationRequest,
  TNearbyHousesExplanationModel,
  IMappers,
  TNearbyHousesExplanationResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { INearbyHousesExplanationResponse } from '../../entities/nearby_houses/NearbyHousesExplanationResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createNearbyHousesExplanationModel(
  parameters: INearbyHousesExplanationRequest,
): TNearbyHousesExplanationModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'valuation-offer-history',
    pathApi: '/v2/nearby-houses-explanation/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface INearbyHousesExplanationOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: INearbyHousesExplanationRequest;
}

export async function fetchNearbyHousesExplanation<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: INearbyHousesExplanationOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TNearbyHousesExplanationResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createNearbyHousesExplanationModel(parameters),
    config,
  )) as FetchResponse<TNearbyHousesExplanationResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as INearbyHousesExplanationResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TNearbyHousesExplanationResponse>;
}
